/**
 * The tracking categories the banner offers.
 */

export interface ConsentCategory {
  id: string;
  label: string;
  description?: string;
  locked?: boolean;
  onEnable: () => void;
  onDisable: () => void;
}

const advertising: ConsentCategory = {
  id: 'advertising',
  label: 'Advertising',
  description: 'Meta and Google',
  onEnable: () => {
    if (typeof window.fbq === 'function') window.fbq('consent', 'grant');
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        ad_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
      });
    }
  },
  onDisable: () => {
    if (typeof window.fbq === 'function') window.fbq('consent', 'revoke');
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
      });
    }
  }
};

const analytics: ConsentCategory = {
  id: 'analytics',
  label: 'Analytics',
  description: 'Google Analytics',
  onEnable: () => {
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        analytics_storage: 'granted',
      });
    }
  },
  onDisable: () => {
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        analytics_storage: 'denied',
      });
    }
  }
};

const essential: ConsentCategory = {
  id: 'essential',
  label: 'Essential',
  description: 'Always on',
  locked: true,
  onEnable: () => {},
  onDisable: () => {}
};

export const DEFAULT_CATEGORIES: ConsentCategory[] = [
  essential,
  analytics,
  advertising
];
